import React, { Fragment } from "react";
import moment from "moment";
function Clock() {
  const [date, setDate] = React.useState(new Date());

  React.useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);

    return function cleanup() {
      clearInterval(timerID);
    };
  });

  function tick() {
    setDate(new Date());
  }

  return (
    <Fragment>
      {moment(date.toISOString()).utc().format("dddd, YYYY-MM-DD HH:mm:ss ") +
        "UTC"}
    </Fragment>
  );
}
export default Clock;
